"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var PublishConfirmationModal = function PublishConfirmationModal(props) {
  var numberOfUsers = props.numberOfUsers,
      isOpen = props.isOpen,
      onSend = props.onSend,
      _onClose = props.onClose,
      isSendButtonDisabled = props.isSendButtonDisabled,
      includeCurrentlyMatchedRecipients = props.includeCurrentlyMatchedRecipients;
  var isAutomated = props.campaignType === 'automated';
  var automatedMessage = (0, _preact.h)("div", null, (0, _preact.h)("p", null, "After publishing, this email will go out to users once they match the criteria you\u2019ve set."), includeCurrentlyMatchedRecipients ? (0, _preact.h)("p", null, "We will also send out this email to ", (0, _preact.h)("span", {
    className: "bold"
  }, numberOfUsers, " users"), " recipients that currently match your criteria.") : null);
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "small"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: isAutomated ? 'You’re about to publish an automated campaign' : 'Ready to send this email campaign?',
    onClose: function onClose() {
      return _onClose();
    }
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
    className: (0, _toKebabCase.statelessFunctionNameToKebab)(PublishConfirmationModal.name)
  }, isAutomated ? automatedMessage : (0, _preact.h)("p", null, "Your email will be sent to ", (0, _preact.h)("span", {
    className: "bold"
  }, numberOfUsers, " users"), " immediately. There\u2019s no turning back once the emails are sent."))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: isAutomated ? 'Publish now' : 'Yes, send email now',
    onClick: onSend,
    size: "medium",
    variant: "brand",
    className: "qa-send-email-campaign",
    disabled: isSendButtonDisabled,
    "data-track-type": "click",
    "data-element-name": "Publish confirmation button"
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: _onClose,
    size: "medium",
    "data-track-type": "click",
    "data-element-name": "Publish cancel button"
  })));
};

var _default = PublishConfirmationModal;
exports.default = _default;